import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./redux/store";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { ToastProvider } from "react-toast-notifications";

const App = React.lazy(() => import(/* webpackChunkName: "App" */ "./App"));

ReactDOM.render(
  <Provider store={store}>
    <ToastProvider autoDismissTimeout={4000} placement="bottom-center">
      <Suspense fallback={<div className="loading" />}>
        <ReactNotification />
        <App />
      </Suspense>
    </ToastProvider>
  </Provider>,
  document.getElementById("root")
);
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
